export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isVerticalMenuCollapsed() {
      return this.$store.state.verticalMenu.isVerticalMenuCollapsed;
    },
  },
  render(h) {
    const span = h('span', {}, this.item.i18n ? this.$t('MAIN_MENU')[this.item.i18n] : this.item.header)
    const icon = h('feather-icon', { props: { icon: 'MoreHorizontalIcon', size: '18' } })
    const headerClass = {class: 'navigation-header text-truncate'}
    if (this.isVerticalMenuCollapsed) {
      headerClass.class += ' no-display';
    }
    return h('li', headerClass, [span, icon])
  },
}
